import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'Services',
    path: '/services'
  }, {
    label: 'AI & Automation',
    path: '/ai-automation'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 bg-white border-b border-neutral shadow-sm" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="flex items-center justify-between h-20" data-id="element-64">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-65">
            <div className="text-2xl font-bold text-primary" data-id="element-66">
              Magnus Software
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-67">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-base font-medium transition-colors duration-200 ${isActive(link.path) ? 'text-primary' : 'text-gray-600 hover:text-primary'}`} data-id="element-68">
                {link.label}
              </Link>)}
          </nav>

          {/* Client Support Button */}
          <div className="hidden md:block" data-id="element-69">
            <a href="tel:231-266-0606" data-id="element-70">
              <Button variant="secondary" size="sm" data-id="element-71">
                231-266-0606
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-primary" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-72">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-73" /> : <MenuIcon size={24} data-id="element-74" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-75">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden border-t border-neutral bg-white" data-id="element-76">
            <nav className="flex flex-col px-4 py-4 gap-2" data-id="element-77">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setMobileMenuOpen(false)} className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${isActive(link.path) ? 'bg-surface text-primary' : 'text-gray-600 hover:bg-surface'}`} data-id="element-78">
                  {link.label}
                </Link>)}
              <a href="tel:231-266-0606" onClick={() => setMobileMenuOpen(false)} className="mt-2" data-id="element-79">
                <Button variant="secondary" size="md" className="w-full" data-id="element-80">
                  231-266-0606
                </Button>
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}